<template>
  <div class="ren-decoration-cp ren-decoration-cp-fortune-card" :style="cardStyle">
    <header>
      <i :style="iconStyle">{{ iconText }}</i>
      <div>
        <strong>{{ title }}</strong>
        <span>{{ subtitle }}</span>
      </div>
    </header>
    <section>
      <div>
        <small>{{ scoreLabel }}</small>
        <b :style="scoreStyle">{{ score }}</b>
      </div>
      <button type="button" :style="buttonStyle">{{ buttonText }}</button>
    </section>
    <footer v-if="metrics.length">
      <i v-for="(metric, index) in metrics" :key="index" :style="{ background: metricColor(metric) }" :title="metricLabel(metric)" />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { recordList, stringValue, styleColorList } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '运势检测卡'))
const subtitle = computed(() => stringValue(props.component.props?.subtitle))
const iconText = computed(() => {
  const value = stringValue(props.component.props?.icon, '问').trim()
  return value.slice(0, 1)
})
const scoreLabel = computed(() => stringValue(props.component.props?.scoreLabel, '今日指引'))
const score = computed(() => stringValue(props.component.props?.score, '98'))
const buttonText = computed(() => stringValue(props.component.props?.buttonText, '添加档案'))
const metrics = computed(() => recordList(props.component.props?.metrics))
const iconStyle = computed(() => ({
  background: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)'
}))
const scoreStyle = computed(() => ({
  color: props.themeTokens?.accentColor || 'var(--ren-theme-primary)'
}))
const buttonStyle = computed(() => ({
  background: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)',
  color: '#fff'
}))
const cardStyle = computed(() => {
  const colors = styleColorList(props.component.style?.gradientColors)
  if (colors.length >= 2) return { background: `linear-gradient(135deg, ${colors[0]}, ${colors[1]})` }
  if (colors.length === 1) return { background: colors[0] }
  return undefined
})

function metricLabel(metric: Record<string, unknown>) {
  return stringValue(metric.label)
}

function metricColor(metric: Record<string, unknown>) {
  return stringValue(metric.color) || props.themeTokens?.primaryColor || 'var(--ren-theme-primary)'
}
</script>

<style scoped>
.ren-decoration-cp-fortune-card {
  background: transparent;
}
</style>
